import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import {FetchAutomaticInvoicingConfig} from '../queries';
import {
    type FetchAutomaticInvoicingConfigQueryVariables,
    type FetchAutomaticInvoicingConfigQuery,
} from '../__generated__/queries.api-types-no-enum';

export const useAutomaticInvoicingConfig = (siteSetId: string) => {
    const [result] = useTransformQuery<
        FetchAutomaticInvoicingConfigQuery,
        FetchAutomaticInvoicingConfigQueryVariables
    >()(
        FetchAutomaticInvoicingConfig,
        {
            variables: {
                siteSetId,
            },
            skip: !hasValue(siteSetId),
            fetchPolicy: 'cache-and-network',
        },
        ({data}) =>
            data
                ? {
                      automaticInvoicingConfig: data.finance.invoices.automaticInvoicing.automaticInvoicingConfig,
                      isOnUsCorePackage: data.finance.invoices.automaticInvoicing.isOnUsCorePackage,
                  }
                : null,
    );

    return {
        automaticInvoicingConfig: result?.automaticInvoicingConfig,
        isOnUsCorePackage: result?.isOnUsCorePackage,
    };
};
